var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-input',{attrs:{"value":_vm.IntDruhDuvod,"disabled":_vm.disabled,"label-key":"INT_DRUH_DUVOD"},on:{"update:value":function($event){_vm.IntDruhDuvod=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }